import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ActionButtonsSettings from "./ActionButtonsSettings";
import LoadingScreen from "../common/LoadingScreen";
import ErrorMessage from "../common/ErrorMessage";
import SuccessMessage from "../common/SuccessMessage";
import { useLayoutContext } from "../../context/LayoutContext";

const ProfileSettings = () => {
  const {
    userSettings,
    setUserSettings,
    systemError,
    setSystemError,
    loading,
    setLoading,
    error,
    setError,
    success,
    setSuccess,
    modalScreen,
    setModalScreen,
    page,
    setPage,
  } = useLayoutContext();
  const { saveProfile } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      const updatedSettings = userSettings as ProfileAndSettings;
      if (!updatedSettings) {
        console.warn("User settings not loaded");
        return;
      }

      if (password.trim().length > 0 && password !== confirmPassword) {
        alert("Passwords don't match");
        return;
      }

      // Update userSettings with the new password if provided
      if (password.trim().length > 0) {
        updatedSettings.profile.password = password;
      }

      console.log("Updated user settings:", updatedSettings);
      const returnUpdatedSettings = await saveProfile(updatedSettings);
      setUserSettings(returnUpdatedSettings);
      setPassword("");
      setConfirmPassword("");
      setSuccess("Perfil atualizado com sucesso!");
    } catch (error) {
      console.warn("Error updating profile:", error);
      setError("Failed to update profile");
    } finally {
      setLoading(null);
    }
  };

  if (!userSettings) {
    return <div>Loading...</div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="box">
        <fieldset>
          <legend className="title is-4">Dados Pessoais</legend>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label is-normal">Nome</label>
            </div>
            <div className="field-body">
              <div className="field is-grouped">
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    name="firstName"
                    placeholder="Primeiro nome"
                    defaultValue={userSettings?.profile.firstName || ""}
                    required={true}
                    onChange={(e) => {
                      if (userSettings) {
                        setUserSettings({
                          ...userSettings,
                          profile: {
                            ...userSettings.profile,
                            firstName: e.target.value,
                          },
                        });
                      }
                    }}
                  />
                </div>
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    name="lastName"
                    placeholder="Apelido"
                    defaultValue={userSettings?.profile.lastName || ""}
                    onChange={(e) => {
                      if (userSettings) {
                        setUserSettings({
                          ...userSettings,
                          profile: {
                            ...userSettings.profile,
                            lastName: e.target.value,
                          },
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label is-normal">Email</label>
            </div>
            <div className="field-body">
              <div className="field is-grouped">
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="email"
                    name="email"
                    required={true}
                    placeholder="seu.email@exemplo.com"
                    defaultValue={userSettings?.profile.email || ""}
                    onChange={(e) => {
                      if (userSettings) {
                        setUserSettings({
                          ...userSettings,
                          profile: {
                            ...userSettings.profile,
                            email: e.target.value,
                          },
                        });
                      }
                    }}
                  />
                </div>
                <div className="field-label is-normal">
                  <label className="label">Telefone</label>
                </div>
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="tel"
                    name="phone"
                    placeholder="123-456-7890"
                    defaultValue={userSettings?.profile.phoneNumber || ""}
                    onChange={(e) => {
                      if (userSettings) {
                        setUserSettings({
                          ...userSettings,
                          profile: {
                            ...userSettings.profile,
                            phoneNumber: e.target.value,
                          },
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label is-normal">Palavra-passe</label>
            </div>
            <div className="field-body">
              <div className="field is-grouped">
                <div className="control">
                  <div className="field has-addons">
                    <div className="control is-expanded">
                      <input
                        className="input"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Palavra-passe"
                        defaultValue={password || ""}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="control">
                      <button
                        type="button"
                        className="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? "Ocultar" : "Mostrar"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="field-label is-normal">
                  <label className="label">Confirmar Palavra-passe</label>
                </div>
                <div className="control">
                  <div className="field has-addons">
                    <div className="control is-expanded">
                      <input
                        className="input"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Palavra-passe"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <div className="control">
                      <button
                        type="button"
                        className="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? "Ocultar" : "Mostrar"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <ActionButtonsSettings />
    </form>
  );
};

export default ProfileSettings;
